import React, { useContext, useEffect, useMemo, useState } from "react";
import { Currencies } from "@orbital/games-frontend-library";
import { ButtonWrapper, Button, NumberOfBets } from "../ElementsStyles";
import {
  AppContext,
  GameBoardContext,
} from "../../../../context/createContext";
import floorFigure from "../../../configs/floorFigure";
// import CashoutSound from "../../../../lib/audio/cashout.mp3"
import BetCancelSFX from "../../../../lib/audio/bet-cancel.mp3";
import useSound from "use-sound";
import { useTranslation } from "../../../../locale/context";

interface BetButton_props {
  handleBet: (s: string, e: any) => void;
  autoPilotNumber: string;
  stake: string;
  cashoutStake: number;
  footerState: "bet" | "cancel" | "cashout" | "stop" | "start auto";
  disabled: boolean;
}

export default function BetButton({
  handleBet,
  autoPilotNumber,
  stake,
  cashoutStake,
  footerState,
  disabled,
}: BetButton_props) {
  const {
    auth,
    audio: { sound, isSoundOff },
    config,
  } = useContext(AppContext);
  const { auto, funcs } = useContext(GameBoardContext);
  const { handleAutoInputs } = funcs;
  const {
    balance: { currency },
  } = auth;

  const { t } = useTranslation();
  const languagePack = useMemo(() => {
    return {
      bet: t("button.bet"),
      cancel: t("button.cancel"),
      cashout: t("button.cashout"),
      stop: t("button.stop"),
      "start auto": t("button.startAutoBet"),
    };
  }, [t]);

  const autoObj = autoPilotNumber === "first" ? auto.first : auto.second;

  const numberOfBets = Number(autoObj.numberOfBets);
  const betCount = Number(autoObj.betCount);

  useEffect(() => {
    const bets = numberOfBets - betCount;
    numberOfBets > 0 && handleAutoInputs(autoPilotNumber, "betsLeft", bets);
  }, [betCount, numberOfBets]);

  const [betSound] = useSound(BetCancelSFX, {
    volume: isSoundOff ? 0 : parseFloat(sound) / 100,
  });

  // const [cashoutSound] = useSound(CashoutSound, {
  //   volume: isSoundOff ? 0 : parseFloat(sound) / 100,
  // })

  const [cashoutAmount, setCashoutAmount] = useState(
    floorFigure(cashoutStake.toString(), 2)
  );
  useEffect(() => {
    if (+cashoutStake >= +autoObj.cashOut && autoObj.showAuto) {
      setCashoutAmount(floorFigure(autoObj.cashOut.toString(), config.prec));
    } else {
      setCashoutAmount(floorFigure(cashoutStake.toString(), config.prec));
    }
  }, [cashoutStake]);

  return (
    <div onClick={() => !disabled && handleBet(autoPilotNumber, stake)}>
      <ButtonWrapper disabled={disabled}>
        <Button
          disabled={disabled}
          background={
            footerState === "cancel" || footerState === "stop"
              ? "red"
              : footerState === "cashout"
              ? "green"
              : ""
          }
          onClick={() => footerState !== "cashout" && betSound()}
        >
          {footerState === "stop" && !numberOfBets ? (
            <span className="state">{languagePack.stop}</span>
          ) : (
            <span className="state">{languagePack[footerState]}</span>
          )}
          {footerState === "cashout" && (
            <span>{Currencies[currency] + cashoutAmount}</span>
          )}
          {footerState === "stop" && Number(numberOfBets) > 0 && (
            <NumberOfBets>{autoObj.betsLeft}</NumberOfBets>
          )}
        </Button>
      </ButtonWrapper>
    </div>
  );
}
